import axiosInstance from "./axiosInstance";

export const sendContactMessage = async (payload: {
  name: string;
  email: string;
  subject: string;
  message: string;
  website: string;
  submittedAt: number;
}) => {
  const res = await axiosInstance.post("/contact", payload);
  return res.data;
};